var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-input',{class:_vm.className,style:(_vm.customStyle),attrs:{"type":"number","value":_vm.value,"size":_vm.size,"max":_vm.maxValue,"min":_vm.minValue},on:{"input":_vm.dispatch,"change":_vm.Cchange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }